import i18n from "@/plugins/vue-i18n";

import Promotions from "@/views/settings/promotions/index";
import PromotionsAdd from "@/views/settings/promotions/add";
import PromotionsEdit from "@/views/settings/promotions/edit";
import PromotionsRanking from "@/views/settings/promotions/ranking";

const promotions = [
  {
    path: "settings/promotions",
    name: "Promotions",
    component: Promotions,
    meta: {
      title: i18n.t("title.promotions._"),
    },
  },
  {
    path: "settings/promotions/add",
    name: "PromotionsAdd",
    component: PromotionsAdd,
    meta: {
      title: i18n.t("title.promotions.add"),
    },
  },
  {
    path: "settings/promotions/:id/edit",
    name: "PromotionsEdit",
    component: PromotionsEdit,
    meta: {
      title: i18n.t("title.promotions.edit"),
    },
  },
  {
    path: "settings/promotions/:id/dealers",
    name: "PromotionsRanking",
    component: PromotionsRanking,
    meta: {
      title: i18n.t("title.promotions.dealers"),
    },
  },
];

export default promotions;
